<template>
    <div>
      <nav-bar-component />
    </div>
    <div class="mt-2 mb-2">
      <div class="buttom-center">
        <input
          type="radio"
          class="btn-check"
          name="options-outlined"
          id="success-outlined"
          autocomplete="off"
          @click="activeButtonMonthOrYear('mes')"
          checked
        />
        <label class="btn btn-outline-primary button-style" for="success-outlined"
          >Mensal</label
        >
        <input
          type="radio"
          class="btn-check"
          name="options-outlined"
          id="danger-outlined"
          autocomplete="off"
          @click="activeButtonMonthOrYear('ano')"
        />
        <label class="btn btn-outline-primary button-style" for="danger-outlined"
          >Anual</label
        >
      </div>
    </div>
    <div class="d-md-flex"> 
      <div class="middle-line col-12"></div>
      <div v-for="plan in dataPlan" :key="plan.id" class="col">
        <cards-plans-component :plans="plan" class="d-flex justify-content-center"/>
      </div>
    </div>
</template>
    
    <script>
export default {
  name: "test-component",
  data() {
    return {
      msg: "Testando aqui o componente",
      buttonMonth: true,
      buttonYear: "",
      dataPlan: [
        {
          plan: "essential",
          value: 976,
          valuePromotion: 887,
          infos: {
            info1: "Gerencie conversas",
            info2: "Agenda de contatos",
            info3: "Relatórios e Analytics",
            info4:
              "Criação de fluxos para automação de processos: Treinamento e gatilhos na inteligência artificial - até 1.000 treinamentos",
            info5:
              "1 Flow (Módulo destinado a construir chatbots estruturados)",
            info6: "2 usuários inclusos",
            info7: "Integração com RD CRM",
          },
        },
        {
          plan: "advanced",
          value: 1427,
          valuePromotion: 1297,
          infos: {
            info1: "Todas as funcionalidades do plano Light",
            info2:
              "Treinamento de gatilhos na inteligência artificial - até 5.000 treinamentos",
            info3:
              "5 Flows (Módulo destinado a construir chatbots estruturados e requisições externas via API)",
            info4: "Pipeline - Funil de Vendas",
            info5: "Cadastro carteira de clientes por operador",
            info6: "Análise de Emoções",
            info7: "2 usuários inclusos",
          },
        },
        {
          plan: "professional",
          value: 2472,
          valuePromotion: 2247,
          infos: {
            info1: "Todas as funcionalidades do plano Basic",
            info2: "Gerente de contas",
            info3: "Flows ilimitados para a contrução de Chatbots Inteligentes",
            info4:
              "Treinamentos de gatilhos na inteligência artificial - ilimitado",
            info5: "API - Webhook",
            info6: "Integração com RD Marketing",
            info7: "2 usuários inclusos",
          },
        },
      ],
    };
  },
  mounted() {
    localStorage.setItem("timePlan", "mes");
    this.buttonMonth = true;
  },
  watch: {
    buttonMonth() {
      localStorage.setItem("timePlan", "mes");
      const typePlans = this.dataPlan.map((item) => item);
      typePlans[0].value = 976;
      typePlans[0].valuePromotion = 887;

      typePlans[1].value = 1427;
      typePlans[1].valuePromotion = 1297;

      typePlans[2].value = 2472;
      typePlans[2].valuePromotion = 2247;
    },
    buttonYear() {
      localStorage.setItem("timePlan", "ano");
      const typePlans = this.dataPlan.map((item) => item);
      typePlans[0].value = 887;
      typePlans[0].valuePromotion = 798;

      typePlans[1].value = 1297;
      typePlans[1].valuePromotion = 1167;

      typePlans[2].value = 2247;
      typePlans[2].valuePromotion = 2022;
    },
  },
  methods: {
    activeButtonMonthOrYear(data) {
      if (data === "mes") {
        this.buttonYear = true;
        this.buttonMonth = false;
      }
      if (data === "ano") {
        this.buttonMonth = true;
        this.buttonYear = false;
      }
    },
  },
};
</script>
    
<style>
.buttom-center {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.middle-line {
  width: 100%;
  height: 250px;
  background: linear-gradient(90deg, #3cbafa 0%, #427f9d 120%);
  position: absolute;
  margin-top: 150px;
}
.buttom-center-next {
  display: flex;
  justify-content: center;
}
.button-style {
  width: 100px;
  height: 35px;
  border-radius: 20px !important;
  font-family: "Nunito";
}
.link-return-tallos {
  display: flex;
  justify-content: center;
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin-top: 10px;
  margin-bottom: 20px;
}
</style>